module.exports = __webpack_public_path__ + "img/108031.2c64641a.png";